import type { Currency } from '@weft/types';
import { isNotNullOrUndefined, isNullOrUndefined } from '@weft/utils';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { shortenNumber } from '../../../../utils/number';

type InvoiceSectionHeaderPriceProps = { price: number, children?: never } | { price?: never, children: React.ReactNode };

type InvoiceSectionHeaderProps = InvoiceSectionHeaderPriceProps & {
  name: string;
  currency: Currency;
  description?:string;
  className?: string,
};

export const InvoiceSectionHeader:React.FC<InvoiceSectionHeaderProps> = ({
  className: externalClassName,
  name,
  description,
  price,
  currency,
  children,
}) => {
  return (
    <div className={twMerge('flex justify-between', externalClassName)}>
      <div>
        <div className="text-xl font-medium text-black">{name}</div>
        <div className="text-base text-black">{description}</div>
      </div>
      {isNullOrUndefined(children) && (
        <div className="text-2xl font-medium text-black">
          <span className="text-lg">{getCurrencySymbol(currency)}</span>
          {shortenNumber(price)}
        </div>
      )}
      {isNotNullOrUndefined(children) && children}
    </div>
  );
};